import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default function HomePage() {
  useEffect(() => {
    axios.post('/api/funnel/event', { evento: 'visita_homepage', pagina: '/' }).catch(() => {});
  }, []);

  return (
    <div className="fade-in">
      {/* Hero */}
      <section className="hero">
        <div className="container">
          <h1>Scopri Tutti gli Incentivi<br />per la Tua Azienda</h1>
          <p>Analisi gratuita e personalizzata tra oltre 75 incentivi nazionali, regionali e fondi europei diretti. Scopri subito a quali agevolazioni hai diritto.</p>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/register" className="btn btn-lg btn-green">Verifica Gratis i Tuoi Incentivi</Link>
            <Link to="/incentivi" className="btn btn-lg btn-outline" style={{ borderColor: 'white', color: 'white' }}>Esplora il Catalogo</Link>
          </div>
          <div className="hero-stats">
            <div className="hero-stat"><div className="number">75+</div><div className="label">Incentivi Disponibili</div></div>
            <div className="hero-stat"><div className="number">€2.5 Mld</div><div className="label">Fondi Disponibili</div></div>
            <div className="hero-stat"><div className="number">1.200+</div><div className="label">Aziende Analizzate</div></div>
            <div className="hero-stat"><div className="number">98%</div><div className="label">Tasso di Soddisfazione</div></div>
          </div>
        </div>
      </section>

      {/* Come Funziona */}
      <section className="section" style={{ background: 'white' }}>
        <div className="container">
          <h2 className="section-title">Come Funziona</h2>
          <p className="section-subtitle">In 4 semplici passi scopri tutti gli incentivi disponibili per la tua azienda</p>
          <div className="grid-4">
            {[
              { icon: '1', title: 'Registrati Gratis', desc: 'Crea il tuo account in meno di 2 minuti. Nessun costo, nessun impegno.' },
              { icon: '2', title: 'Compila il Profilo', desc: 'Inserisci i dati della tua azienda: settore, regione, fatturato e dipendenti.' },
              { icon: '3', title: 'Carica la Visura', desc: 'Carica la visura camerale per un\'analisi IA automatica del profilo aziendale.' },
              { icon: '4', title: 'Ricevi il Report', desc: 'Ottieni il report personalizzato con tutti gli incentivi compatibili e le istruzioni.' }
            ].map((step, i) => (
              <div key={i} className="card" style={{ textAlign: 'center' }}>
                <div style={{ width: 50, height: 50, borderRadius: '50%', background: 'linear-gradient(135deg, #1a56db, #16a34a)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, fontWeight: 800, margin: '0 auto 16px' }}>{step.icon}</div>
                <h3 style={{ marginBottom: 8 }}>{step.title}</h3>
                <p style={{ fontSize: 14, color: '#6b7280' }}>{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Report Personalizzato — promo 49,90 (prezzo reale: REPORT_PRICE nel .env del backend) */}
      <section className="section" style={{ background: '#f8fafc' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 className="section-title">Il Tuo Report Personalizzato</h2>
          <p className="section-subtitle">Dall'analisi gratuita al report completo con tutti gli incentivi compatibili</p>
          <div className="grid-3" style={{ maxWidth: 900, margin: '0 auto' }}>
            <div className="card" style={{ textAlign: 'center', border: '2px solid #e5e7eb', position: 'relative' }}>
              <div style={{ background: '#16a34a', color: 'white', padding: '4px 16px', borderRadius: 20, fontSize: 12, fontWeight: 700, display: 'inline-block', marginBottom: 12 }}>GRATIS</div>
              <h3 style={{ marginBottom: 8 }}>Preanalisi</h3>
              <div style={{ fontSize: 32, fontWeight: 800, color: '#16a34a', marginBottom: 8 }}>€0</div>
              <ul style={{ textAlign: 'left', fontSize: 14, color: '#374151', lineHeight: 2, listStyle: 'none', padding: 0 }}>
                <li>✓ Registrazione gratuita</li>
                <li>✓ Matching con 75+ incentivi</li>
                <li>✓ Anteprima compatibilità</li>
                <li>✓ Analisi IA della visura</li>
              </ul>
              <Link to="/register" className="btn btn-green" style={{ marginTop: 16, width: '100%' }}>Inizia Gratis</Link>
            </div>
            <div className="card" style={{ textAlign: 'center', border: '2px solid #1a56db', position: 'relative', transform: 'scale(1.05)', boxShadow: '0 8px 30px rgba(26,86,219,0.15)' }}>
              <div style={{ background: '#1a56db', color: 'white', padding: '4px 16px', borderRadius: 20, fontSize: 12, fontWeight: 700, display: 'inline-block', marginBottom: 12 }}>PIÙ POPOLARE</div>
              <h3 style={{ marginBottom: 8 }}>Report Completo</h3>
              <div style={{ marginBottom: 4 }}>
                <span style={{ fontSize: 20, fontWeight: 600, color: '#9ca3af', textDecoration: 'line-through', marginRight: 10 }}>€197</span>
                <span style={{ fontSize: 32, fontWeight: 800, color: '#1a56db' }}>€49,90</span>
              </div>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#dc2626', marginBottom: 8, letterSpacing: 0.5 }}>OFFERTA A TEMPO LIMITATO</div>
              <ul style={{ textAlign: 'left', fontSize: 14, color: '#374151', lineHeight: 2, listStyle: 'none', padding: 0 }}>
                <li>✓ Tutto della Preanalisi</li>
                <li>✓ Report dettagliato completo</li>
                <li>✓ Importi e scadenze esatti</li>
                <li>✓ Istruzioni passo-passo</li>
                <li>✓ Link fonti ufficiali</li>
              </ul>
              <Link to="/report-incentivi" className="btn btn-primary" style={{ marginTop: 16, width: '100%' }}>Ottieni il Report</Link>
            </div>
            <div className="card" style={{ textAlign: 'center', border: '2px solid #059669', position: 'relative' }}>
              <div style={{ background: '#059669', color: 'white', padding: '4px 16px', borderRadius: 20, fontSize: 12, fontWeight: 700, display: 'inline-block', marginBottom: 12 }}>PREMIUM</div>
              <h3 style={{ marginBottom: 8 }}>Gestione Bandi</h3>
              <div style={{ fontSize: 32, fontWeight: 800, color: '#059669', marginBottom: 8 }}>€1.000<span style={{ fontSize: 16, fontWeight: 400 }}> + 5%</span></div>
              <ul style={{ textAlign: 'left', fontSize: 14, color: '#374151', lineHeight: 2, listStyle: 'none', padding: 0 }}>
                <li>✓ Tutto del Report</li>
                <li>✓ Preparazione documenti</li>
                <li>✓ Presentazione domanda</li>
                <li>✓ Follow-up fino all'esito</li>
                <li>✓ Paghi il 5% solo se approvato</li>
              </ul>
              <Link to="/gestione-bandi" className="btn" style={{ marginTop: 16, width: '100%', background: '#059669', color: 'white' }}>Scopri di Più</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Incentivi in Evidenza */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">Incentivi in Evidenza</h2>
          <p className="section-subtitle">Alcuni dei principali incentivi attualmente disponibili per le imprese italiane</p>
          <div className="grid-3">
            {[
              { nome: 'Conto Termico 3.0', tipo: 'Contributo a fondo perduto', livello: 'Nazionale', agevolazione: 'Fino al 65%', importo: '€5.000.000' },
              { nome: 'Credito Imposta Industria 4.0', tipo: 'Credito d\'imposta', livello: 'Nazionale', agevolazione: '20% beni materiali', importo: '€20.000.000' },
              { nome: 'Nuova Sabatini', tipo: 'Contributo in conto interessi', livello: 'Nazionale', agevolazione: '2,75-3,575% annuo', importo: '€4.000.000' },
              { nome: 'Resto al Sud', tipo: 'Fondo perduto + finanziamento', livello: 'Nazionale', agevolazione: '50% fondo perduto', importo: '€200.000' },
              { nome: 'Smart&Start Italia', tipo: 'Finanziamento agevolato', livello: 'Nazionale', agevolazione: 'Tasso zero fino all\'80%', importo: '€1.500.000' },
              { nome: 'ZES Unica Mezzogiorno', tipo: 'Credito d\'imposta', livello: 'Nazionale', agevolazione: '15-45%', importo: '€100.000.000' },
            ].map((inc, i) => (
              <div key={i} className="incentivo-card">
                <span className="badge badge-nazionale">{inc.livello}</span>
                <h3>{inc.nome}</h3>
                <div className="tipo">{inc.tipo}</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 12 }}>
                  <div><small style={{ color: '#6b7280' }}>Agevolazione</small><br /><strong style={{ fontSize: 13 }}>{inc.agevolazione}</strong></div>
                  <div style={{ textAlign: 'right' }}><small style={{ color: '#6b7280' }}>Importo Max</small><br /><strong style={{ fontSize: 13 }}>{inc.importo}</strong></div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 32 }}>
            <Link to="/incentivi" className="btn btn-primary btn-lg">Vedi Tutti i 42 Incentivi</Link>
          </div>
        </div>
      </section>

      {/* Gestione Bandi Banner - NUOVO */}
      <section className="section" style={{ background: 'linear-gradient(135deg, #059669 0%, #047857 50%, #1a56db 100%)', color: 'white' }}>
        <div className="container">
          <div className="grid-2" style={{ alignItems: 'center', gap: 40 }}>
            <div>
              <div style={{ display: 'inline-block', background: 'rgba(255,255,255,0.15)', padding: '4px 14px', borderRadius: 20, fontSize: 12, fontWeight: 600, marginBottom: 16 }}>
                NUOVO SERVIZIO
              </div>
              <h2 style={{ fontSize: 30, fontWeight: 700, marginBottom: 16, lineHeight: 1.3 }}>
                Gestione Bandi Professionale:<br />Ci Pensiamo Noi a Tutto
              </h2>
              <p style={{ fontSize: 16, opacity: 0.9, lineHeight: 1.7, marginBottom: 20 }}>
                Non hai tempo di gestire la burocrazia? Il nostro team di esperti si occupa dell'intero iter: dalla documentazione alla presentazione della domanda, fino all'approvazione del contributo.
              </p>
              <div style={{ display: 'flex', gap: 24, marginBottom: 24, flexWrap: 'wrap' }}>
                <div>
                  <div style={{ fontSize: 28, fontWeight: 800 }}>90%+</div>
                  <div style={{ fontSize: 13, opacity: 0.8 }}>Tasso di Successo</div>
                </div>
                <div>
                  <div style={{ fontSize: 28, fontWeight: 800 }}>€2.8M+</div>
                  <div style={{ fontSize: 13, opacity: 0.8 }}>Contributi Ottenuti</div>
                </div>
              </div>
              <Link to="/gestione-bandi" className="btn btn-lg" style={{ background: 'white', color: '#047857', fontWeight: 700 }}>
                Scopri il Servizio
              </Link>
            </div>
            <div style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 16, padding: 32, backdropFilter: 'blur(10px)' }}>
              <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 16 }}>Cosa Facciamo per Te:</h3>
              {['Analisi di fattibilità gratuita', 'Preparazione documentazione completa', 'Presentazione domanda sui portali', 'Follow-up fino all\'approvazione', 'Paghi il 5% solo se approvato'].map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, fontSize: 14 }}>
                  <span style={{ color: '#86efac', fontSize: 18 }}>&#10003;</span> {item}
                </div>
              ))}
              <div style={{ borderTop: '1px solid rgba(255,255,255,0.2)', marginTop: 16, paddingTop: 16, textAlign: 'center' }}>
                <div style={{ fontSize: 13, opacity: 0.7 }}>A partire da</div>
                <div style={{ fontSize: 28, fontWeight: 800 }}>€1.000 + 5%</div>
                <div style={{ fontSize: 12, opacity: 0.7 }}>anticipo + success fee sul deliberato</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cessione Crediti Banner */}
      <section className="section" style={{ background: 'linear-gradient(135deg, #1a56db, #0f3a8e)', color: 'white' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 style={{ fontSize: 32, marginBottom: 16 }}>Cessione Crediti Fiscali Edilizi</h2>
          <p style={{ fontSize: 18, opacity: 0.9, maxWidth: 600, margin: '0 auto 24px' }}>
            Hai crediti fiscali da Superbonus, Ecobonus o Sismabonus? Monetizzali subito con il nostro servizio di cessione.
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 40, marginBottom: 24, flexWrap: 'wrap' }}>
            <div><div style={{ fontSize: 36, fontWeight: 800 }}>80%</div><div style={{ opacity: 0.8 }}>Trattieni tu</div></div>
            <div><div style={{ fontSize: 36, fontWeight: 800 }}>15%</div><div style={{ opacity: 0.8 }}>Acquirente</div></div>
            <div><div style={{ fontSize: 36, fontWeight: 800 }}>5%</div><div style={{ opacity: 0.8 }}>Piattaforma</div></div>
          </div>
          <Link to="/cessione-crediti" className="btn btn-lg btn-green">Scopri di Piu</Link>
        </div>
      </section>

      {/* Testimonials */}
      <section className="section" style={{ background: 'white' }}>
        <div className="container">
          <h2 className="section-title">Cosa Dicono i Nostri Clienti</h2>
          <div className="grid-3">
            <div className="testimonial">
              <div className="stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
              <div className="quote">"Grazie a VerificaIncentivi ho scoperto 8 incentivi di cui non ero a conoscenza. Il report e stato fondamentale per la mia azienda."</div>
              <div className="author">Mario R.</div>
              <div className="role">Imprenditore, Settore Manifatturiero</div>
            </div>
            <div className="testimonial">
              <div className="stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
              <div className="quote">"Servizio eccellente e professionale. L'analisi della visura camerale con l'IA e stata rapidissima e accurata. Consiglio vivamente."</div>
              <div className="author">Laura C.</div>
              <div className="role">Commercialista, Studio Professionale</div>
            </div>
            <div className="testimonial">
              <div className="stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>
              <div className="quote">"Il team ha gestito la mia pratica per un bando regionale in modo impeccabile. 35.000€ di contributo approvato senza stress."</div>
              <div className="author">Marco B.</div>
              <div className="role">Titolare Azienda Agricola, Sicilia</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section" style={{ background: '#f0fdf4', textAlign: 'center' }}>
        <div className="container">
          <h2 className="section-title">Inizia Ora, e Gratis</h2>
          <p className="section-subtitle">Registrati in meno di 2 minuti e scopri subito gli incentivi disponibili per la tua azienda</p>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/register" className="btn btn-lg btn-green">Registrati Gratis</Link>
            <Link to="/gestione-bandi" className="btn btn-lg btn-outline">Oppure Affidati a Noi</Link>
          </div>
          <p style={{ marginTop: 16, fontSize: 13, color: '#6b7280' }}>Nessuna carta di credito richiesta. Nessun impegno.</p>
        </div>
      </section>
    </div>
  );
}
